import { defineStore } from 'pinia'
import { getMeetingAssistantConfig, getAnalysisConfigList } from '@/api'

export const useSystemSetStore = defineStore('system', {
  state: () => ({
    linkCommunicatePlanEnable: true,
    refiningCommunicatePlanEnable: true,
    recommendTaskEnable: true,
    isEmployeePerform: false,
    hasEnableRule: 0
  }),

  actions: {
    setLinkCommunicatePlanEnable(val) {
      this.linkCommunicatePlanEnable = val
    },
    setRefiningCommunicatePlanEnable(val) {
      this.refiningCommunicatePlanEnable = val
    },
    setRecommendTaskEnable(val) {
      this.recommendTaskEnable = val
    },
    setIsEmployeePerform(isEmployeePerform) {
      this.isEmployeePerform = isEmployeePerform
    },
    async getIsActionAdvice() {
      return getMeetingAssistantConfig({ type: 1 }).then(({ result }) => {
        if (result?.data) {
          try {
            const config = JSON.parse(result.data.config || '{}')
            this.linkCommunicatePlanEnable = !!config.linkCommunicatePlanEnable
            this.refiningCommunicatePlanEnable = !!config.refiningCommunicatePlanEnable
            this.recommendTaskEnable = !!config.recommendTaskEnable
          } catch (error) {}
        }
      })
    },
    async getIsEmployeePerform() {
      return getAnalysisConfigList().then(({ result }) => {
        this.isEmployeePerform = !!result.enable
        this.hasEnableRule = result.hasEnableRule
      })
    }
  }
})
